import { useState } from "react";

import { makePostApiCall } from "../../../shared/makeApiCall";
import { BannerNotificationType } from "../../../components/SimpleBanner";
import ModelErrorComponent from "../../../components/modals/ModelErrorComponent";

export function ProductViewModel(logout, productId) {
  const [allergensOptions, setAllergensOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [product, setProduct] = useState({});
  const [productTypeOptions, setProductTypeOptions] = useState([]);
  const [priceRuleOptions, setPriceRuleOptions] = useState([]);
  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });
  const [unitOfMeasureOptions, setUnitOfMeasureOptions] = useState([]);
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const user_id = localStorage.getItem("id") * 1;

  const getProduct = async function (search, page) {
    setLoading(true);
    const payload = { id: productId };
    let callResult = await makePostApiCall(`products/${productId}`, payload);

    if (callResult.success) {
      setProduct(callResult.data.product);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
    setLoading(false);
  };

  const createProduct = async function (values) {
    const payload = { ...values, user_id: user_id };
    let callResult = await makePostApiCall(
      "createProduct",
      payload,
      "multipart/form-data"
    );

    if (callResult.success) {
      window.location = "/my-products/" + callResult.data.product.id;
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const updateProduct = async function (product, values) {
    let callResult = await makePostApiCall(
      `updateProduct/${product.id}`,
      values,
      "multipart/form-data"
    );
    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Product updated",
        type: BannerNotificationType.Success,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const updateProductPriceRulePrice = async function (
    productId,
    priceRuleId,
    availability,
    unitPrice
  ) {
    let callResult = await makePostApiCall(`updateProductPriceRulePrice`, {
      product_id: productId,
      price_rule_id: priceRuleId,
      availability: Boolean(availability),
      unit_price: unitPrice,
    });

    if (callResult.success) {
      const normalizedAvailability = Boolean(callResult.data.availability);
      const normalized =
        callResult.data.unit_price === null ||
        callResult.data.unit_price === undefined
          ? null
          : callResult.data.unit_price;

      setProduct((prev) => ({
        ...prev,
        price_rule_prices: (prev.price_rule_prices || []).map((row) =>
          row.price_rule_id === priceRuleId
            ? {
                ...row,
                availability: normalizedAvailability,
                unit_price: normalized,
              }
            : row
        ),
      }));

      return true;
    }

    if (callResult.errorStatus === 401) {
      logout();
    }
    showErrorModal(callResult.data.message || "Could not update price rule price");
    return false;
  };

  const getAllergensForDropdown = async function () {
    let callResult = await makePostApiCall(`allergensForDropdown`);

    if (callResult.success) {
      setAllergensOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not load allergens");
    }
  };

  const getUnitOfMeasuresForDropdown = async function () {
    let callResult = await makePostApiCall(`unitOfMeasuresForDropdown`);

    if (callResult.success) {
      setUnitOfMeasureOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not load unit of measure types");
    }
  };

  const getProductTypes = async function () {
    let callResult = await makePostApiCall(`productTypesForDropdown`);

    if (callResult.success) {
      setProductTypeOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not load product types");
    }
  };

  const getPriceRulesForDropdown = async function () {
    let callResult = await makePostApiCall(`priceRulesForDropdown`, {});

    if (callResult.success) {
      setPriceRuleOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const showErrorModal = (subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title="Error"
        />
      ),
      open: true,
    });
  };

  return {
    allergensOptions,
    createProduct,
    getAllergensForDropdown,
    getProduct,
    loading,
    product,
    setShowSimpleNotification,
    showSimpleNotification,
    updateProduct,
    updateProductPriceRulePrice,
    getUnitOfMeasuresForDropdown,
    unitOfMeasureOptions,
    getProductTypes,
    productTypeOptions,
    getPriceRulesForDropdown,
    priceRuleOptions,
    emptyModal,
    setEmptyModelOpen,
  };
}
